// src/constants/sectionData.ts
export const sections = [
    'Vision, Mission & Mission KPIs',
    
    
   
];

export const sectionPaths: { [key: string]: string } = {
    'Vision, Mission & Mission KPIs': '/strategy',
};